// extracted by mini-css-extract-plugin
module.exports = {"linkButtonStyle":"style_linkButtonStyle__A7Mwz","callLinkStyle":"style_callLinkStyle__dvxq6","linkButtonStyleWithIcon":"style_linkButtonStyleWithIcon__OvYJg"};